import React from 'react';
import { translate } from 'i18n/localize';
import proofpointLogo from 'components/images/proofpoint_logo.svg';

const PreLoginHeader = ({ signInHref = '/sign_in' }) => (
  <header id='header-container'>
    <div id='proofpoint_logo_pre_login'>
      <img src={proofpointLogo} alt='Proofpoint' />
      <span>{translate('proofpoint_subtitle')}</span>
    </div>
    <a id='utility_sign_in_button' href={signInHref}>{translate('login_sign_in')}</a>
  </header>
);

export default PreLoginHeader;
